import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import{UserServices} from '../services/userservices.service'
@Component({
  selector: 'app-verifyperson',
  templateUrl: './verifyperson.component.html',
  styleUrls: ['./verifyperson.component.css']
})
export class VerifypersonComponent implements OnInit {
  
  patientDetails:any;
  userProfileImage: string = "assets/img/user.png";
  documentFile:any;
  selectedDocumentFile:any;
  constructor(private userServices:UserServices) {
    debugger
    this.patientDetails=this.userServices.getPatientData()
    console.log(this.patientDetails)
    //this.userProfileImage = 'https://s3.amazonaws.com/sasadoctorimages/profileImages/03878b60-4b12-11e9-ab94-e305d8838097.JPG'
    this.userProfileImage=this.patientDetails.patientIdentityImagePath;
   }
  

  ngOnInit() {
  }
  
  getUploadFile(imageInput: any, event: any) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      this.documentFile = event.target.files[0];
      reader.readAsDataURL(event.target.files[0]); // read file as data url
  
      reader.onload = (e:any) => { 
        // called once readAsDataURL is completed
        debugger
        this.selectedDocumentFile = e.target.result;
      }
    }
  }

}
